import React,{useState,useEffect,useCallback} from 'react'
// import ReCAPTCHA from 'react-google-recaptcha';
import './workshopdetails.css'
import { NavLink } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import workshop02 from '../../../images/workshop_images/workshop02.jpg'
import duration from '../../../images/workshop_images/duration.png'
import language from '../../../images/workshop_images/language.png'
import timings from '../../../images/workshop_images/timing.png'
import start_date from '../../../images/workshop_images/start-date.png'
import fees from '../../../images/workshop_images/money.png'
import location from '../../../images/workshop_images/loction.png'
import learn01 from '../../../images/workshop_images/learn01.png'
import learn02 from '../../../images/workshop_images/learn02.png'
import learn03 from '../../../images/workshop_images/learn03.png'
import accept from '../../../images/workshop_images/accept.png'
import health_seekers from '../../../images/workshop_images/health_seekers.png'
import working from '../../../images/workshop_images/working.png'
import homemakers from '../../../images/workshop_images/homemakers.png'
import student from '../../../images/workshop_images/student.png'
import parents from '../../../images/workshop_images/parents.png'
import teenagers from '../../../images/workshop_images/teenage.png'
import cross from '../../../images/workshop_images/cross.png'
import wisdom from '../../../images/workshop_images/wisdom.png'
import science_backed from '../../../images/workshop_images/science_backed.png'
import holistic from '../../../images/workshop_images/holistic.png'
import expert from '../../../images/workshop_images/expert.png'
import support from '../../../images/workshop_images/support.png'


function CountdownTimer({ targetDate }) {
    const calculateTimeLeft = useCallback(() => {
        const difference = new Date(targetDate) - new Date();
        if (difference > 0) {
            const days = Math.floor(difference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((difference / 1000 / 60) % 60);
            const seconds = Math.floor((difference / 1000) % 60);
            return { days, hours, minutes, seconds };
        }
        return null;
    }, [targetDate]);

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [calculateTimeLeft]);

    if (!timeLeft) {
        return <p className="text-danger">The workshop has started!</p>;
    }

    return (
        <div className="countdown-timer">
            <div className="time-box">
                <span>{timeLeft.days}</span>
                <small>Days</small>
            </div>
            <div className="time-box">
                <span>{timeLeft.hours}</span>
                <small>Hours</small>
            </div>
            <div className="time-box">
                <span>{timeLeft.minutes}</span>
                <small>Minutes</small>
            </div>
            <div className="time-box">
                <span>{timeLeft.seconds}</span>
                <small>Seconds</small>
            </div>
        </div>
    );
}



function WorkshopDetails02() {

    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const accordionData = [
        {
            title: "What happens after I register? ",
            content:
                "After you submit your details through the Contact Us form, our team will provide you with payment instructions. Complete the payment and share the screenshot with us. Your seat will be confirmed once the payment is verified.",
        },
        {
            title: " How can I stay connected after the workshop? ",
            content: (
                <>
                    You can join Anuyog’s WhatsApp Group to continue your journey toward natural living with like-minded individuals.{" "}
                    <a href="https://chat.whatsapp.com/JEe0oM19XXd4LHjicaIzgf" target="_blank" rel="noopener noreferrer">
                        Join Here
                    </a>
                </>
            ),
        },
        {
            title: "Does the workshop offer a recorded session or a live session?",
            content:
                "The workshop is conducted live by our expert facilitators, providing real-time interaction ",
        },
        {
            title: " How can I prepare for the workshop?",
            content: [
                "Ensure a stable internet connection for the online sessions.",
                "Keep a notebook and pen handy for taking notes.",
                "Be ready to participate actively and implement the learnings.",
            ],
            type: "list",
        },
        {
            title: "Can I get a refund if I cannot attend?",
            content:
                "Refunds are not available, but you can transfer your spot to someone else if you notify us in advance.",
        },
        {
            title: " Can I access recordings if I miss a session?",
            content:
                "Currently, live participation is encouraged for the best experience. Recordings may be offered in future workshops.",
        },
        {
            title: "Will there be an interactive component?",
            content:
                "Yes! Each day includes an interactive Q&A session where you can ask questions and clarify your doubts.",
        },
        {
            title: "Will I receive a confirmation email after registering?",
            content:
                "Yes, once you complete the registration process, you will receive a confirmation email with all the necessary details about the workshop, including the schedule and joining instructions. Make sure to check your inbox (and spam folder) for this email.",
        },
        {
            title: "How can I stay connected after the workshop?",
            content:
                "You can join Anuyog’s Whatapp Group (https://chat.whatsapp.com/JEe0oM19XXd4LHjicaIzgf) to continue your journey toward natural living with like-minded individuals. ",
        },
    ];


    // const [formData, setFormData] = useState({
    //     name: '',
    //     email: '',
    //     phone: '',
    // });

    // const [isSubmitting, setIsSubmitting] = useState(false);
    // const [message, setMessage] = useState('');
    // const [recaptchaToken, setRecaptchaToken] = useState(null);
    // const [recaptchaError, setRecaptchaError] = useState(false);
    const workshopDate = '2025-06-08T14:00:00'




    useEffect(() => {
        AOS.init({ duration: 1500, easing: 'ease-in-out' });
    }, []);

    // const handleChange = (e) => {
    //     const { id, value } = e.target;
    //     setFormData((prev) => ({ ...prev, [id]: value }));
    // };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setIsSubmitting(true);
    //     setMessage('');

    //     if (!recaptchaToken) {
    //         setMessage('Please complete the reCAPTCHA');
    //         setIsSubmitting(false);
    //         return;
    //     }

    //     try {
    //         const response = await fetch('https://efsouls.pythonanywhere.com/smtp_api/', {
    //             method: 'POST',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify(formData),
    //         });

    //         if (response.ok) {
    //             setMessage('Thank you for registering! We will contact you soon.');
    //             setFormData({ name: '', email: '', phone: '' });
    //         } else {
    //             setMessage('Something went wrong. Please try again later.');
    //         }
    //     } catch (error) {
    //         setMessage('An error occurred. Please try again.');
    //     } finally {
    //         setIsSubmitting(false);
    //     }
    // };

    // const handleRecaptchaChange = (token) => {
    //     if (token) {
    //         setRecaptchaToken(token);
    //         setRecaptchaError(false);
    //     } else {
    //         setRecaptchaError(true);
    //     }
    // };
    return (
        <>
            <section className="book-section register_detail">
                <div className="container">
                    <div className='book register_book'>
                        <div className="book-text" data-aos="fade-right" data-aos-duration="2000">
                            <h1 className='text-start'>Healing Simplified
                            </h1>
                            <h4 className='fw-bold text-start mb-4'><strong>Unlock Healing with Nature's Cure
                            </strong></h4>
                            <div className="countdown mt-4">
                                <h5 className="mb-3 fw-bold text-start">Workshop Will Start In:</h5>
                                <CountdownTimer targetDate={workshopDate} />
                            </div>
                            <div className="how mt-4">
                                <NavLink
                                    to='/contact'
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                      }}
                                >
                                    <button type="button" className="btn">Register Now</button>
                                </NavLink>
                            </div>
                            <p className='mt-4
                            
                            '><strong style={{ color: '#9D3B24' }}>Learn to take charge of your health with natural healing.</strong></p>
                        </div>
                        <div className="success-vidio image-wrapper">
                            <img src={workshop02} alt="" srcset="" />
                        </div>
                    </div>
                </div>
            </section>


            <section className='is_this_you-section'>
                <div className="container">
                    <h1 className='text-center offering-title mb-5'>Is This You?</h1>
                    <div className="is_this_you">
                        <ul>
                            <li><strong>Worried about medicine side effects and dependency?
                            </strong></li>
                            <li><strong>Confused by too much health advice and unsure where to start?</strong></li>
                            <li><strong>Looking for natural, non-violent, and eco-friendly ways to heal?
                            </strong></li>
                            <li><strong>Want to uncover the root cause of your health issues and find lasting solutions?
                            </strong></li>
                        </ul>
                        <h3 className='fw-bold text-success'>If you answered 'YES' to any of the above, this workshop is for you!</h3>
                    </div>
                </div>
            </section>





            <section className='info-section' id='workshop_details'>
                <div className="details">
                    <h2 className='text-center fw-bold mb-4'>Details Of The Workshop</h2>
                    <div className="all-details workshop-details">


                        <div className="block" data-aos="fade-right" data-aos-duration="2000">
                            <h5 className='text-start'><img src={start_date} alt="" /><strong> Date:</strong> 8 June 2025</h5>
                        </div>

                        <div className="block" data-aos="fade-right" data-aos-duration="2000">
                            <h5 className='text-start'><img src={language} alt="" /><strong>Language:</strong> Hindi and English</h5>
                        </div>
                        <div className="block" data-aos="fade-left" data-aos-duration="2000">
                            <h5 className='text-start'><img src={timings} alt="" /><strong> Timings:</strong> 2:00 PM - 3:30 PM IST</h5>

                        </div>
                        <div className="block" data-aos="fade-left" data-aos-duration="2000">

                            <h5 className='text-start'><img src={duration} alt="" /><strong>Duration:</strong> 90 minutes </h5>
                        </div>
                        <div className="block" data-aos="fade-right" data-aos-duration="2000">

                            <h5 className='text-start'><img src={fees} alt="" /><strong>Course Fee:</strong> <s>Rs. 349</s> Rs. 199 </h5>
                        </div>
                        <div className="block" data-aos="fade-right" data-aos-duration="2000">

                            <h5 className='text-start'><img src={location} alt="" /><strong> Location:</strong> Online </h5>
                        </div>
                    </div>
                </div>
            </section>




            <section className='why-join-section pillar-section'>
                <div className="container">
                    <div className="pillar">
                        <h2 className='mb-4' data-aos="fade-down" data-aos-duration="3000"><strong style={{ color: '#9D3B24' }}>Why Join This Workshop?</strong></h2>
                        <h4 className='fw-bold mb-5 offering-title' data-aos="fade-down" data-aos-duration="3000">
                        This isn’t your average health talk—it’s a session designed to inspire and empower you to live better!
                        </h4>
                    </div>
                    <div className="all-pillar">
                        <div className="pillar-detail">
                            <div className="pillar-image">

                                <img src={wisdom} alt="" />
                            </div>
                            <div className="pillar-text">
                                <h5 className='fw-bold'>Ancient Wisdom</h5>
                                <h6 className='fw-bold'>Naturopathy and Jain philosophies made practical.</h6>
                            </div>
                        </div>

                        <div className="pillar-detail">
                            <div className="pillar-image">
                                <div>
                                    <img src={science_backed} alt="" />
                                </div>
                            </div>
                            <div className="pillar-text">
                                <h5 className='fw-bold'>Science-Backed </h5>
                                <h6 className='fw-bold'>Proven insights you can trust.</h6>
                            </div>
                        </div>
                        <div className="pillar-detail">
                            <div className="pillar-image">

                                <img src={holistic} alt="" />

                            </div>
                            <div className="pillar-text">
                                <h5 className='fw-bold'>Holistic Approach  </h5>
                                <h6 className='fw-bold'>Focus on Body, Mind, Soul, and Sustainability</h6>
                            </div>
                        </div>
                        <div className="pillar-detail">
                            <div className="pillar-image">
                                <div>
                                    <img src={expert} alt="" />
                                </div>
                            </div>
                            <div className="pillar-text">
                                <h5 className='fw-bold'>Expert Driven</h5>
                                <h6 className='fw-bold'>Live-session led by a Nature Cure practitioner, Neuroscientist, & Data Science Leader</h6>
                            </div>
                        </div>
                        <div className="pillar-detail">
                            <div className="pillar-image">
                                <img src={support} alt="" />
                            </div>
                            <div className="pillar-text">
                                <h5 className='fw-bold'>Personalized Support</h5>
                                <h6 className='fw-bold'>Tailored advice via Anuyog Consultancy.</h6>
                            </div>
                        </div>
                    </div>
                </div>

            </section>







            <section className='what_learn-section' id='workshop_details'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="include">
                                <h1 className='text-center'>What You’ll Learn?</h1>
                                <h5 className='fw-bold text-center'>We’ll make it simple, fun, and insightful, diving into:
                                </h5>
                                <div className="include-details">
                                    <div className="include-images">
                                        <img src={learn01} alt="" />
                                    </div>
                                    <div className="include-text">
                                        <h2 className='fw-bold text-start'>Why Use Natural Resources to Heal Yourself?

                                        </h2>
                                        <ul className='text-start'>
                                            <li>Understand the foundational reasons behind the power of nature's remedies.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="include-details">
                                    <div className="include-images">
                                        <img src={learn02} alt="" />
                                    </div>
                                    <div className="include-text">
                                        <h2 className='fw-bold text-start'>What Are the Natural Healers?
                                        </h2>
                                        <ul className='text-start'>
                                           <li>Explore different types of natural healers and what science has to say about their benefits.
                                           </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="include-details">
                                    <div className="include-images">
                                        <img src={learn03} alt="" />
                                    </div>
                                    <div className="include-text">
                                        <h2 className='fw-bold text-start'>How to Use Natural Healers in Your Health Journey?

                                        </h2>
                                        <ul className='text-start'>
                                            <li>Discover how to incorporate these natural healers into your everyday life—from the comfort of your home.
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <NavLink
                                to="/contact"
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                            >
                                <div className="right-block">
                                    <h4 className='fw-bold'>Healing Simplified</h4>
                                    <h6 className='text-dark fw-bold mb-4'>Unlock Healing with Nature's Cure
                                    </h6>
                                    <ul className='text-start'>
                                        <li className='fw-bold text-dark'>
                                            <img src={start_date} alt="" />
                                            8 June 2025
                                        </li>
                                        <li className='fw-bold text-dark'>
                                            <img src={fees} alt="" />
                                            Fees: <s>Rs. 349</s> Rs.199
                                        </li>
                                        <li className='fw-bold text-dark'>
                                            <img src={timings} alt="" />
                                            2:00 PM to 3:30 PM IST
                                        </li>
                                    </ul>
                                    <h5 className='fw-bold'>Step into a Healthier, Happier Lifestyle—Naturally!</h5>
                                    <h6 className='fw-bold text-dark'>Begin your journey to a healthy, meaningful life in just 90 minutes—don’t miss out!
                                    </h6>
                                    <div className="how mt-4">

                                        <button type="button" className="btn">Register Now</button>

                                    </div>
                                </div>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </section>

            <section className='host-section' id='workshop_details'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <h1 className='mb-2 mt-5'>About Our Host</h1>
                            <div className="host">

                                <div className="host-image">
                                    <img src="/images/prgati_jain.png" alt="" />
                                </div>
                                <div className="host-text">
                                    <h2 className='fw-bold'>Dr.Pragati Jain</h2>
                                    <p>Dr. Pragati Jain is a passionate advocate of natural living, seamlessly blending ancient wisdom with modern science using cutting-edge technology. With a Ph.D. in Computational Neuroscience, Pragati has spent the last three years expanding her knowledge as a Nature Cure practitioner, while also pursuing formal studies in Naturopathy. As a leader in the field of artificial intelligence, she brings a unique, data-driven approach to holistic health.
                                    </p>
                                    <p>Her personal journey includes running several half marathons across various locations in India, further fueling her dedication to a balanced and healthy lifestyle. Pragati’s multi-disciplinary expertise equips her to guide others toward achieving optimal health through sustainable practices and informed choices.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='yes-section' id='workshop_details'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="yes">
                                <div className="yes-header">
                                    <h1>Who is this for?</h1> <img src={accept} alt="" />
                                </div>
                                <h5 className='fw-bold text-start'>The course is designed for everyone seeking a balanced and healthier lifestyle.</h5>
                                <div className="all-information">
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={health_seekers} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>For Health Seekers</h4>
                                            <h5 className='fw-bold'>Aiming to improve their overall well-being.</h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={working} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>For Working Professionals</h4>
                                            <h5 className='fw-bold'>Simplify your busy life and prioritize your health.
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={homemakers} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>For Homemakers</h4>
                                            <h5 className='fw-bold'>Take time for yourself while supporting your family.
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={student} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>For Students</h4>
                                            <h5 className='fw-bold'>Enhance focus, energy, and personal growth.
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={parents} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>For Parents</h4>
                                            <h5 className='fw-bold'>Pass on lifelong healthy habits to your kids.
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="details">
                                        <div className="details-image">
                                            <img src={teenagers} alt="" />
                                        </div>
                                        <div className="details-text">
                                            <h4 className='fw-bold'>For Teenagers & Young Adults</h4>
                                            <h5 className='fw-bold'>Build habits for a disease-free future.
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="yes-header mt-5">
                                    <h1>Who is it not for?</h1> <img src={cross} alt="" />
                                </div>
                                <h5 className='fw-bold text-start'>This program isn't suitable for those not serious about their health.</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='register_faq-section' id='workshop_details'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="register-faq">
                                <h1>FAQs</h1>
                                <div className="faq-image">
                                    <img src={workshop02} alt="" />
                                </div>
                                <div className="accordion justify-content-center">
                                    {accordionData.map((item, index) => (
                                        <div className="accordion-item" key={index}>
                                            <button
                                                className="accordion-button"
                                                aria-expanded={activeIndex === index ? 'true' : 'false'}
                                                onClick={() => toggleAccordion(index)}
                                            >
                                                <span className="accordion-title">{item.title}</span>
                                                <span className="icon" aria-hidden="true"></span>
                                            </button>
                                            {activeIndex === index && (
                                                <div className="accordion-content">
                                                    {item.type === "list" ? (
                                                        <ul>
                                                            {item.content.map((listItem, i) => (
                                                                <li key={i}>{listItem}</li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <p>{item.content}</p>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="register-section" id="register-form">
                <div className="form-container">
                    <div className="form-wrapper">
                        <h2 className="form-title">Join Us Today</h2>
                        <p className="form-description">Fill out the form below to get started!</p>
                        <form className="register-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <input
                                    type="text"
                                    id="name"
                                    placeholder="Enter your name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <input
                                type="hidden"
                                name="subject"
                                value="Registration form Submission"
                            />
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    placeholder="Enter your email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="phone">Phone Number</label>
                                <input
                                    type="tel"
                                    id="phone"
                                    placeholder="Enter your phone number"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="col-md-12 recaptcha-container register-recaptcha">
                                <ReCAPTCHA
                                    sitekey="6Lda7XYqAAAAAA9wI26_P6V4r9o8pws3uRnM-_GL"
                                    onChange={handleRecaptchaChange}
                                />
                                {recaptchaError && (
                                    <p style={{ color: 'red' }}>reCAPTCHA failed to load. Please try again.</p>
                                )}
                            </div>
                            <button type="submit" className="submit-button" disabled={isSubmitting}>
                                {isSubmitting ? 'Submitting...' : 'Submit'}
                            </button>
                        </form>
                        {message && <p className="form-message">{message}</p>}
                    </div>
                </div>
            </section> */}
        </>
    )
}

export default WorkshopDetails02
